import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Switch, useNotify } from '@hotjar/hotsauce';

import * as unbounceApi from '../../domains/unbounce/api';
import { useIntegrations } from '../../hooks/use-integrations';
import { IntegrationTokenName } from '../../domains/api';

interface UnbounceActionsProps {
  siteId: string | null;
  actionLabel: Record<string, string>;
  isAdmin: boolean;
}

export const UnbounceActions = ({
  siteId,
  actionLabel,
  isAdmin,
}: UnbounceActionsProps): JSX.Element => {
  const { t } = useTranslation();
  const { showToast } = useNotify();
  const { integrations, refreshTokens } = useIntegrations(Number(siteId));
  const { isEnabled = false } =
    integrations.find((integration) => integration.tokenName === IntegrationTokenName.Unbounce) ??
    {};
  const [tagRecordings, setToggleRecordings] = useState(isEnabled);

  useEffect(() => {
    setToggleRecordings(isEnabled);
  }, [isEnabled]);

  const handleTagRecordingsSwitchChange = async (isChecked: boolean) => {
    const state = isChecked ? 'enabled' : 'disabled';

    try {
      await unbounceApi.update(isChecked, Number(siteId));
      setToggleRecordings(isChecked);
      refreshTokens();
      showToast({ text: t(`integrations:page.activation.success.${state}`), kind: 'success' });
    } catch {
      setToggleRecordings(false);
      showToast({ text: t(`integrations:page.activation.error.${state}`), kind: 'danger' });
    }
  };

  return (
    <Switch
      labelContent={t(actionLabel.tagRecordings)}
      isChecked={tagRecordings}
      onChange={handleTagRecordingsSwitchChange}
      isDisabled={!isAdmin}
    />
  );
};
